import { RootState } from '../rootReducer'

export const selectFormData = (state: RootState) => state.form.data
export const selectFormDataRequest = (state: RootState) => state.form.dataRequest
export const selectFormAdditionalErrors = (state: RootState) => state.form.additionalErrors
export const selectFormAdditionalErrorsRequest = (state: RootState) => state.form.additionalErrorsRequest
export const selectFormErrorExternal = (state: RootState) => state.form.errorExternal
